<template>
  <!--
    The panel is fixed-positioned and sits alongside the content rather than inside it, so the
    content can be pulled in beside it. Same arrangement as the default layout.

    It has to be in the DOM at all times: `layoutStore.openSidePanel` only sets store state, and
    without a mounted panel to render it a testbed page's "Edit config" button appears to do
    nothing at all.
  -->
  <AppRightPanel />

  <!--
    No width — a block element fills what is left after its margins, so the content genuinely
    narrows when the panel opens. Setting `width: 100%` would keep it full-width and let the panel
    cover its right edge, which is exactly where a widget keeps its hover controls.
  -->
  <div
    class="h-screen overflow-hidden transition-[margin] duration-300 ease-in-out"
    :style="{ marginRight: `${marginRight}rem` }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { RIGHT_PANEL_WIDTH } from "~/composables/useAppLayout";

const { isRightPanelOpen } = useAppLayout();
const marginRight = computed(() => (isRightPanelOpen.value ? RIGHT_PANEL_WIDTH : 0));
</script>
